export default __webpack_public_path__ + "static/chromeIcon-bf41c366eb7578f9fe5eae17531a8007.svg";